import { useState } from 'react';
import { ProjectDto, ReportDto } from '@/core';
import { Col, Pagination } from 'antd';
import type { PaginationProps } from 'antd';
import { ReportCard } from './ReportCard';
import { ReportsFiltersByDate } from './ReportsFiltersByDate';
import { NotificationNoReports } from './NotificationNoReports';
import { ReportsListNoReport } from './ReportsListNoReport';
import classes from './SavedProjects.module.scss';

type SavedProjectsProps = {
  projectData: ProjectDto;
};

export const SavedProjects = ({ projectData }: SavedProjectsProps) => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState(20);
  const [reportsFilteredByDate, setReportsFilteredByDate] = useState<ReportDto[]>(projectData.reports);
  const currentReports = reportsFilteredByDate.slice(
    (currentPage - 1) * pageSize,
    (currentPage - 1) * pageSize + pageSize,
  );

  const handleChangePage: PaginationProps['onChange'] = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  return (
    <div>
      {projectData.reports.length ? (
        <Col xs={24} md={18} lg={14}>
          <div className={classes.savedProjectWrapper}>
            <ReportsFiltersByDate reports={projectData.reports} setReports={setReportsFilteredByDate} />
            {currentReports.length ? (
              currentReports.map((report) => <ReportCard key={report.id} {...report} />)
            ) : (
              <NotificationNoReports />
            )}
          </div>
        </Col>
      ) : (
        <ReportsListNoReport />
      )}
      <div className={classes.pagination}>
        <Pagination
          hideOnSinglePage
          total={reportsFilteredByDate.length}
          current={currentPage}
          onChange={handleChangePage}
          pageSize={pageSize}
        />
      </div>
    </div>
  );
};
